module.exports = __webpack_public_path__ + "img/12-about.0ebea916.jpg";